import React, {Component} from "react";
import "./ProjectFilter.css";

import {joinClasses} from "utils";

export default class ProjectFilter extends Component
{
	setFilter(data)
	{
		this.props.onChangeFilter(data);
	}

	render()
	{
		const tabs = this.props.categories.map((data, i) =>
		{
			const classes = joinClasses(
			[
				"tab",
				(this.props.filter === data && "active"),
			]);
			
			return (
				<div key={i} onClick={() => this.setFilter(data)} className={classes}>
					{data}
				</div>
			);
		});

		return (
			<div className="project-filter">
				{tabs}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Portfolio/Projects/ProjectFilter/ProjectFilter.js